import React, { Component } from 'react';
import dayjs from 'dayjs';

import services from '@C/Reports/_utils/data';
import {
  formatCurrency,
  TableGrid,
  export2Excel,
  export2PDF,
} from '@C/TableGrid';
import DropLoaderLarge from '@C/Utils/DropLoaderLarge';

const col = [
  {
    name: 'Date',
    key: 'datetime_stamp',
    sortable: true,
    type: 'date',
  },
  {
    name: 'Product',
    key: 'product_name',
  },
  {
    name: 'Price',
    key: 'price',
  },
];

class FuelPriceReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fuelPriceList: [],
      date: dayjs().format('YYYY-MM-DD'),
      product_id: '',
      loading: false,
      limit: 20,
      offset: 1,
      count: 0,
    };
    this.limitInput = React.createRef();
  }

  componentDidMount() {
    this.getFuelPrice();
  }

  handleDateChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  getFuelPrice = () => {
    services
      .getFuelPrice(this.state)
      .then((response) => {
        this.setState({
          fuelPriceList: response.data.data.fuel_prices,
          loading: false,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };
  handleQuickSearch = (e) => {
    if (e.target.value === '' || e.target.value === '0') {
      return;
    }
    this.setState({ limit: e.target.value, offset: 1 }, function () {
      this.getFuelPrice();
    });
  };

  submitForm = (e) => {
    e.preventDefault();
    this.setState({ loading: true }, function () {
      this.getFuelPrice();
    });
  };

  resetFilter = () => {
    this.setState(
      {
        date: dayjs().format('YYYY-MM-DD'),
        loading: true,
      },
      function () {
        this.getFuelPrice();
      },
    );
  };

  render() {
    const { fuelPriceList } = this.state;
    const exportOptions = {
      fileName: ` Fuel Price History - ${this.state.start_date} to ${this.state.end_date}`,
      reportName: 'Fuel Price History Report',
      reportDate: `Date - ${dayjs(this.state.date).format('D MMM YY')}`,
      reportTotal: '',
      reportQuantity: '',
      reportSaleTotal: '',
      reportTCSTotal: '',
      reportSales: '',
      reportTesting: '',
      reportBowser: '',
      reportCustomerName: '',
      reportGst: '',
      reportOpeningBalance: '',
      reportClosingBalance: '',
    };
    return (
      <section className="widget full-width list-table inverted">
        <header>
          <div className="stock-info-headers">
            <h3>Fuel Price History ({this.state.count})</h3>
          </div>
          <div className="action">
            <button className="submit" type="submit" onClick={this.submitForm}>
              Filter
            </button>
            <button
              onClick={this.resetFilter}
              className="reset-filter"
            ></button>
          </div>
          <div className="export-btns">
            <button
              onClick={() => export2Excel(exportOptions)}
              className={`blue-btn btn-with-icon btn-with-icon__excel action-btn ${this.state.exportingExcel ? 'loading' : ''}`}
              title="Export to Excel"
            >
              Export to Excel
            </button>
            <button
              onClick={() => export2PDF(exportOptions)}
              className={`blue-btn btn-with-icon btn-with-icon__pdf action-btn ${this.state.exportingPdf ? 'loading' : ''}`}
              title="Export to PDF"
            >
              Export to PDF
            </button>
          </div>
        </header>
        <main>
          <div className="table-filters">
            <div className="filter-wrapper">
              <div className="filter-group">
                <label>Date:</label>
                <input
                  className="cstm-date-input"
                  type="date"
                  value={this.state.date}
                  name="date"
                  onChange={this.handleDateChange}
                />
              </div>
            </div>
          </div>
          <div className="table-wrapper">
            {(() => {
              if (this.state.loading) {
                return <DropLoaderLarge />;
              } else {
                return (
                  <TableGrid
                    col={col}
                    row={fuelPriceList}
                    offset={this.state.offset}
                    count={this.state.count}
                    limit={this.state.limit}
                    pagination="disabled"
                    hideActions={true}
                    enableExport={false}
                    recordsFilter={this.handleQuickSearch}
                    exportOptions={{
                      fileName: ` Fuel Price History - ${this.state.start_date} to ${this.state.end_date}`,
                      reportName: 'Fuel Price History Report',
                      reportDate: `Date - ${dayjs(this.state.date).format('D MMM YY')}`,
                      reportTotal: '',
                      reportQuantity: '',
                      reportSaleTotal: '',
                      reportTCSTotal: '',
                      reportSales: '',
                      reportTesting: '',
                      reportBowser: '',
                      reportCustomerName: '',
                      reportGst: '',
                      reportOpeningBalance: '',
                      reportClosingBalance: '',
                    }}
                  />
                );
              }
            })()}
          </div>
        </main>
      </section>
    );
  }
}

export { FuelPriceReport };
